import styled from 'styled-components';

const StyledSelectCss = styled.div`
  // width: 100%;
  .async-select {
    width: 100%;
    [class*='-container'] {
      width: 100%;
    }

    input {
      color: ${({ theme }) => theme?.dark ? theme?.headingColor : theme.textColor} !important;
    }

    [class$='-control'][aria-disabled="true"] {
      background-color:var(--bs-async-select-disable-bg) !important; /* Replace with your desired color */
    }

    [class$='-menu'] {
    z-index:999 !important;
      @-moz-document url-prefix() {
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => theme.scroll} transparent;
      }
      ::-webkit-scrollbar {
        width: 7px;
        background-color: ${({ theme }) => theme.bodyBg};
      }

      ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.inputBorder};
        border-radius: 5px;
      }

      ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px ${({ theme }) => theme.inputColor};
        background-color: ${({ theme }) => `${theme.darkLight || theme.white}`};
      }
      background-color: ${({ theme }) =>
        theme?.dark ? theme.surface || theme.selectBg : theme.white} !important;
      border: 1px solid
        ${({ theme }) =>
          theme?.dark ? 'rgba(255, 255, 255, 0.16)' : 'rgba(13, 35, 73, 0.08)'} !important;
      box-shadow: ${({ theme }) => theme?.shadowMd || '0 4px 16px rgba(0, 0, 0, 0.15)'};
      border: none !important;
      font-size: 12px;
      font-weight: 600;
      color: ${({ theme }) => theme.headingColor};
      padding: 10px;
      border-radius: ${({ theme }) => theme?.radiusMd || '12px'};
      &:active,
      &:focus {
        box-shadow: none !important;
      }

      &:focus {
        outline: none;
      }

      &:hover {
        color: ${({ theme }) => theme.headingColor};
      }
    }
    [class$='-option'] {
     &:active,
     &:focus,
     &:hover{
        background-color: ${({ theme }) =>
          theme?.dark ? theme?.bodyColor : theme.primaryLight};
      }
    }
    [class$='-control'] {
      border-color: ${({ theme }) => theme.inputBorder} !important;
      background: ${({ theme }) =>
        theme?.cardSurface
          ? 'transparent'
          : theme?.dark
            ? theme?.selectBg
            : theme.white} !important;
      box-shadow: none !important;
      border-radius: ${({ theme }) => theme?.radiusSm || '8px'};
      font-size: 0.9rem;
      font-size: 16px !important;
      -webkit-text-size-adjust: 100% !important;
      height: 100%;
      cursor: pointer;
      padding-block: 2px;
      transition: border-color 0.15s ease, box-shadow 0.15s ease;
    
    }
    [class$='-control']:hover {
      border-color: ${({ theme }) => theme?.dark ? theme.secondary : theme.primaryLight2} !important;
    }
    [class$='-control']:focus-within {
      border-color: ${({ theme }) => theme?.dark ? theme.secondary : theme.primary} !important;
      box-shadow: 0 0 0 3px ${({ theme }) => theme?.dark ? 'rgba(220, 96, 30, 0.2)' : 'rgba(13, 35, 73, 0.12)'} !important;
    }
      [class$='-singleValue'] {
          color: ${({ theme }) => theme?.dark ? '#e8e8e8' : 'auto'};
}

    &.workFlow {
      [class$='-menu'] {
        position: absolute;
        z-index: 9999;
        // background-color:red;
      }
    }

    &.application {
      [class$='-control'] {
        border: none;
      }
    }

    &.analytics {
      [class$='-control'] {
        [class$='-ValueContainer'] {
          &:hover {
            [class$='-singleValue'] {
              color: ${({ theme }) => theme.primary};
            }
          }

          [class$='-singleValue'] {
            color: ${({ theme }) => theme?.bodyColor} !important;
            font-size: 14px !important;
          }
        }
        cursor: pointer;
        background: transparent;
        font-size: 14px;
        font-weight: 600;
        border: 0;
        padding-block: 0px;
      }

      [class$='-menu'] {
        white-space: nowrap;
        width: fit-content;
      }
      [class$='-indicatorContainer'] {
        color: ${({ theme }) => theme?.bodyColor};
        [class$='-Svg'] {
          height: 18px;
          width: 18px;
          stroke: ${({ theme }) => theme?.bodyColor};
          fill: ${({ theme }) => theme?.bodyColor};
        }
      }
    }

    &.publicForm {
      [class$='-menu'] {
        background: ${({ theme }) =>
          `linear-gradient(to bottom, ${theme?.backgroundColor}, ${theme?.backgroundColor}db)`};

        @include shadow();
        border: none !important;
        font-size: 12px;
        font-weight: 600;

        [class$='-option'] {
          color: ${({ theme }) => theme.primary};
          margin-bottom: 2px;

          &:active,
          &:focus {
            box-shadow: none !important;
          }

          &:focus {
            outline: none;
          }

          &:hover {
            color: ${({ theme }) => theme.primary};
          }
        }
      }

      [class$='-control'] {
        border: none;
        background-color: transparent !important;
        // color: ${({ theme }) => theme.inputBorder} !important;
        border-bottom: 1px solid;
        border-color: ${({ theme }) => theme.primary} !important;
        border-radius: 0;

        [class$='-indicatorContainer'] {
          color: ${({ theme }) => theme.primary} !important;
        }
        [class$='-singleValue'] {
          color: ${({ theme }) => theme.primary} !important;
          font-weight: 500;
        }
        [class$='-ValueContainer'] {
          padding: 2px 2px 2px 10px;

          [class$='-placeholder'] {
            color: ${({ theme }) => theme.primary} !important;
          }
          [class$='-Input'] {
            color: ${({ theme }) => theme.primary} !important;
          }
        }

        &:hover,
        &:active,
        &:focus {
          border-bottom: 2px solid
            ${({ theme }) => theme.darkLight || theme.white};
        }
      }
    }

    &.customBorder {
      [class$='-control'] {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    [class$='-indicatorContainer'] {
      padding: 5px 10px 5px 5px;
    }

    [class$='-ValueContainer'] {
      padding: 2px 2px 2px 10px;
    }

    [class$='-placeholder'] {
      color: ${({ theme }) => theme.inputPlaceHolder};
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 85%;
    }

    [class$='-indicatorSeparator'] {
      display: none;
    }

    [class$='-multiValue'] {
      border-radius: 6px;
      background-color: ${({ theme }) =>
        theme?.dark ? 'rgba(142, 224, 176, 0.16)' : '#e0f2f1'};
      color: ${({ theme }) =>
        theme?.dark ? '#8EE0B0' : theme?.textColor} !important;
       [class$='-MultiValueGeneric'] {
        color: ${({ theme }) =>
          theme?.dark ? '#8EE0B0' : theme?.textColor} !important;
        }
      &>div,
      &>label{
       color: ${({ theme }) =>
         theme?.dark ? '#8EE0B0' : theme?.textColor} !important;
      }
      padding: 0 4px;
      font-weight: 600;
      font-size: 12px;
      margin-right: 5px;

      [role='button'] {
        padding-right: 2px;

        &:hover {
          color: ${({ theme }) => theme.headingColor};
        }
      }

      div:last-child:hover {
        background-color: transparent;
      }

      &:nth-child(even) {
        background: ${({ theme }) =>
          theme?.dark ? 'rgba(194, 211, 235, 0.18)' : '#fcf1e9'};
        color: ${({ theme }) =>
          theme?.dark ? '#C2D3EB' : theme?.textColor} !important;
        [class$='-MultiValueGeneric'] {
        color: ${({ theme }) =>
          theme?.dark ? '#C2D3EB' : theme?.textColor} !important;
        }
      }
    }

    &.is-invalid {
      [class$='-control'] {
        border-color: ${({ theme }) => theme.danger} !important;
      }
    }

    //&.is-valid {
    //  [class$='-control'] {
    //    border-color: $success !important;
    //  }
    //}

    &.pay {
      width: max-content;
    }

    &.is-light-pink {
      [class$='-control'] {
        border-color: transparent;
        font-weight: 600;
        background-color: ${({ theme }) => theme?.dark ?theme.primaryLight2 : theme?.primaryLight} !important;
        color: ${({ theme }) => theme.primary} !important;
        label{
        color: ${({ theme }) => theme.primary} !important;
        }
      }

      [class$='-indicatorContainer'] {
        color: ${({ theme }) => theme.primary} !important;
      }
    }
  }
  .team_member {
    [class$='-multiValue'] {
      border-radius: 30px;
      color: ${({ theme }) => theme?.dark ? theme?.headingColor : theme?.textColor} !important;
      background-color: ${({ theme }) => theme.teamLabelbg};

      // padding: 4px 8px;

      font-weight: 600;

      font-size: 12px;

      margin-right: 5px;

      

      [role='button'] {
        padding-right: 2px;

        &:hover {
          color: ${({ theme }) => theme.headingColor};
        }
      }

      div:last-child:hover {
        background-color: transparent;
      }

      &:nth-child(even) {
        background: ${({ theme }) => theme.teamLabelbg};
        color: ${({ theme }) => theme?.dark ? theme?.headingColor : theme?.textColor} !important;
        [class$='-MultiValueGeneric'] {
        color: ${({ theme }) => theme?.dark ? theme?.headingColor : theme?.textColor} !important;
        }
      }
    }
  }
`;
export default StyledSelectCss;
